import { Skeleton } from "@mui/material";

const ImageSkeleton = () => (
  <Skeleton
    sx={{
      height: 155,
      width: 224,
      borderRadius: "1rem",
      transform: "none",
      marginBottom: "0.5rem",
    }}
  />
);

export default ImageSkeleton;
